const DANH_SACH_HO_SO_DU_KIEN = (state, danhSachHoSoDuKien) => {
  state.danhSachHoSoDuKien = danhSachHoSoDuKien;
};
const DANH_SACH_HO_SO = (state, danhSachHoSo) => {
  state.danhSachHoSo = danhSachHoSo;
};
const DANH_SACH_HO_SO_DANH_THUC_HIEN = (state, danhSachHoSoDangThucHien) => {
  state.danhSachHoSoDangThucHien = danhSachHoSoDangThucHien;
};
const THEM_HO_SO_DU_KIEN = (state, themHoSoDuKien) => {
  state.themHoSoDuKien = themHoSoDuKien;
};

const THEM_HO_SO = (state, themHoSoDuKien) => {
  state.themHoSo = themHoSoDuKien;
};

const SET_DANH_SACH_COT_HO_SO = (state, danhSachHienThiCotHoSo) => {
  state.danhSachHienThiCotHoSo = danhSachHienThiCotHoSo;
};

const CAP_NHAT_DANH_SACH_COT_HO_SO = (state, danhSachHienThiCotHoSoCapNhat) => {
  state.danhSachHienThiCotHoSoCapNhat = danhSachHienThiCotHoSoCapNhat;
};
const DANH_SACH_HO_SO_DON_VI_NOP_DANH_MUC = (state, danhSachHienThiCotHoSoCapNhat) => {
  state.danhSachDonViNopDanhMucHoSo = danhSachHienThiCotHoSoCapNhat;
};

const DANH_SACH_Y_KIEN = (state, danhSachYKien) => {
  state.danhSachYKien = danhSachYKien;
}

const DANH_SACH_LICH_SU = (state, danhSachLichSu)=>{
  state.danhSachLichSu = danhSachLichSu
}

const SET_HO_SO_DE_MUC = (state, payload) => {
  state.hoSoDeMuc = payload;
}


const DANH_SACH_NGUOI_LAP_HO_SO = (state, danhSachNguoiLapHoSo) => {
  state.danhSachNguoiLapHoSo = danhSachNguoiLapHoSo
}

export default {
  THEM_HO_SO,
  DANH_SACH_HO_SO_DON_VI_NOP_DANH_MUC,
  DANH_SACH_HO_SO_DU_KIEN,
  DANH_SACH_HO_SO,
  DANH_SACH_HO_SO_DANH_THUC_HIEN,
  THEM_HO_SO_DU_KIEN,
  SET_DANH_SACH_COT_HO_SO,
  CAP_NHAT_DANH_SACH_COT_HO_SO,
  DANH_SACH_Y_KIEN,
  DANH_SACH_LICH_SU,
  SET_HO_SO_DE_MUC,
  DANH_SACH_NGUOI_LAP_HO_SO,
};
